import { Alert } from '@fountain/fountain-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IdleMoveRule } from 'containers/WorkflowEditor/components/IdleMoveRule';
import { Rules } from 'containers/WorkflowEditor/components/Rules';
import { StageSection } from 'containers/WorkflowEditor/components/StageSection';
import { StageSettingMessageCard } from 'containers/WorkflowEditor/components/StageSettingMessageCard';
import { RulesEditDataContextProvider } from 'containers/WorkflowEditor/RulesEditDataContextProvider/RulesEditDataContextProvider';

import { messages } from './messages';
import {
  RehireCheckStageProps,
  RehireCheckStageSettings,
} from './RehireCheckStageSettings';

export default function RehireCheckStage({ stage }: RehireCheckStageProps) {
  const isSubstage = stage.parent_stage_id;

  return (
    <div data-testid="RehireCheckStage">
      <RulesEditDataContextProvider externalId={stage.external_id}>
        <StageSection>
          <RehireCheckStageSettings stage={stage} />
        </StageSection>
        <StageSection>
          <Alert type="informational" fullWidth>
            <FormattedMessage {...messages.ruleOrderingHint} />
          </Alert>
          <Rules stage={stage} useExistingDataContext />
        </StageSection>
      </RulesEditDataContextProvider>
      {!isSubstage && (
        <>
          <StageSection>
            <IdleMoveRule stage={stage} />
          </StageSection>
          <StageSection>
            <StageSettingMessageCard
              messageType="automated"
              stageExternalId={stage.external_id}
            />
          </StageSection>
          <StageSection>
            <StageSettingMessageCard
              messageType="trigger"
              stageExternalId={stage.external_id}
            />
          </StageSection>
        </>
      )}
    </div>
  );
}
